// PageLayoutContext.js — Permite que una página (PaginaView, etc.) indique
// que tiene header/footer propios, para que el Layout global los oculte y
// no queden duplicados.
import React, { createContext, useContext, useState, useCallback } from 'react';

const PageLayoutContext = createContext({
  pageHasHeader: false,
  pageHasFooter: false,
  setPageLayout: () => {},
});

export const PageLayoutProvider = ({ children }) => {
  const [layout, setLayout] = useState({ pageHasHeader: false, pageHasFooter: false });

  const setPageLayout = useCallback((partial) => {
    setLayout(prev => ({ ...prev, ...partial }));
  }, []);

  return (
    <PageLayoutContext.Provider value={{ ...layout, setPageLayout }}>
      {children}
    </PageLayoutContext.Provider>
  );
};

export const usePageLayout = () => useContext(PageLayoutContext);
